require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ru-pages-exhibit-application-demo.json") })
        }
      }, "path---ru-pages-exhibit-application-demo");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ru-pages-exhibit-application-demo!./.cache/json/ru-pages-exhibit-application-demo.json
// module id = 784
// module chunks = 231608221292675